import { call, put } from 'redux-saga/effects';
import { saveChartOfAccounts } from '../api';
import {
  saveChartOfAccountsFailure,
  saveChartOfAccountsSuccess,
  fetchChartOfAccountsForOrganisationRequest,
} from '../actions';
import { SaveChartOfAccountsRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn, turnDrawerOff } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* saveChartOfAccountsSaga(
  action: SaveChartOfAccountsRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, accountIds } = action.payload;

    const response: ApiResponse = yield call(
      saveChartOfAccounts,
      organisationId,
      accountIds
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // For now, just trigger success and let the reducer set loading to false.
    yield put(saveChartOfAccountsSuccess());

    // Refresh organisation chart of accounts from backend so organisation object is up to date
    yield put(fetchChartOfAccountsForOrganisationRequest(organisationId));

    // Close the drawer after a successful save and refresh
    yield put(turnDrawerOff());

    // If you later want to update accounts for the connection, uncomment and adapt:
    // const updatedAccounts: CoaAccountRow[] = response?.data?.accounts ?? [];
    // yield put(updateChartOfAccountsForConnection(connectionId, updatedAccounts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveChartOfAccountsFailure());
  }
}

